export const Emails = {
  Feedback: "adam@adamsmith.cc"
}
